/**
 * Create a new category
 * @param {string} API_BASE - Base API URL
 * @param {string} token - JWT token
 * @param {Object} payload - Category payload { name: string }
 * @returns {Promise<Object>} Created category object
 */
async function createCategory(API_BASE, token, payload) {
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    };

    const response = await fetch(`${API_BASE}/categories`, {
        method: "POST",
        headers,
        body: JSON.stringify(payload)
    });

    if (!response.ok) {
        throw new Error("Erreur création de la catégorie: " + (await response.text()));
    }

    return await response.json();
}

export default createCategory;
